import { Button, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, Avatar, Stack } from '@mui/material';
import { Trash01 } from '../../../assets'; 
import { useTranslation } from 'react-i18next'; 
import CloseIcon from '@mui/icons-material/Close';
import { theme } from '../../../theme';   

export interface POSMappingDeleteModalProps  {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isPaperPackaging?: boolean; 
}

const POSMappingDeleteModal = (props: POSMappingDeleteModalProps) => {  
  const { t } = useTranslation('posMapping');
  
  const deleteTitle = props.isPaperPackaging ? t('deletePaperPackingMappingTitle') : t('deletePOSMappingTitle');
  const deleteMessage = props.isPaperPackaging 
    ? t('deletePaperPackingMappingConfirmMessage')
    : t('deletePOSMappingConfirmMessage');
  
  return (  
    <Dialog
      fullWidth
      maxWidth='sm'
      open={props.open}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            sx={{
              backgroundColor: theme.palette.error[100],
              color: theme.palette.error[700],
            }}
          > 
            <Trash01 color={theme.palette.error[500]} />
          </Avatar>
        </Box>
        <IconButton
          onClick={props.onCancel}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton> 
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}>{deleteTitle}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1, whiteSpace: 'pre-line' }}
            variant="textSM">
            {deleteMessage}
          </Typography> 
        </Stack>
      </DialogContent>
      <DialogActions sx={{
        padding: '0px 24px 24px',
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px',
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          <Button
            fullWidth
            variant="secondary"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={props.onCancel}>
            {t('cancel')}
          </Button>
          <Button
            fullWidth
            variant="bad"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={props.onConfirm}
          >
            {t('delete')}
          </Button>
        </Stack>
      </DialogActions> 
    </Dialog>
  );
}; 

export default POSMappingDeleteModal;
